import { getStoryBySlug } from "../story/requests";
import { About } from "./entities";

const getAboutPage = () => getStoryBySlug("about").then(About)

export { getAboutPage };
